var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5813 2.90301C20.4733 2.47159 20.2534 2.0763 19.9438 1.75708C19.6341 1.43785 19.2457 1.20599 18.8178 1.08492C17.2542 0.703125 11 0.703125 11 0.703125C11 0.703125 4.74578 0.703125 3.18222 1.12129C2.75429 1.24236 2.36588 1.47421 2.05623 1.79344C1.74659 2.11266 1.52666 2.50795 1.41868 2.93937C1.13253 4.52616 0.992553 6.13585 1.00052 7.74821C0.99032 9.37272 1.1303 10.9947 1.41868 12.5934C1.53773 13.0114 1.76258 13.3917 2.0715 13.6974C2.38043 14.0032 2.76299 14.2241 3.18222 14.3388C4.74578 14.7569 11 14.7569 11 14.7569C11 14.7569 17.2542 14.7569 18.8178 14.3388C19.2457 14.2177 19.6341 13.9859 19.9438 13.6666C20.2534 13.3474 20.4733 12.9521 20.5813 12.5207C20.8653 10.9459 21.0052 9.34843 20.9995 7.74821C21.0097 6.12371 20.8697 4.50174 20.5813 2.90301Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95459 10.7208L14.1816 7.74821L8.95459 4.77563V10.7208Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.88f5703e4ecb6fb9fb03e41ab68d9e47.svg";
export { ForwardRef as ReactComponent };